import cities from '@/util/city_data.json'

export default {
    getDropDownList(){
        return cities
    },
    /***********************************************************************************************
     *
     * Convert an array to a drop-down list.
     * @param {[number[]]} array like: [[city value, township value], [city value, township value]]
     * @return {[Object[]]} res like: [[children: (...), label: (...), value: (...)], ...]
     *
     ***********************************************************************************************/
    arrayToDropDownList(array) {
        let res = [];
        let resIndex = 0;

        for (let i = 0; i < array.length; ++i){
            for (let j = 0; j < cities.length; ++j){
                if (cities[j].value === array[i][0]){
                    res.push({value: cities[j].value, label: cities[j].label, children:[]});

                    for (let k = 0; k < cities[j].children.length; k++){
                        if (array[i][1] === cities[j].children[k].value){
                            res[resIndex].children.push({
                                value: cities[j].children[k].value,
                                label: cities[j].children[k].label
                            })

                            if (i + 1 < array.length && array[i][0] === array[i+1][0]){
                                i += 1;
                            }
                        }
                    }
                    resIndex += 1;
                }
            }
        }

        return res;
    },
    /*********************************************************************
     *
     * Convert an array to words. Example: [15, 225] -> "臺南市安平區"
     * @param {number[]} array like: [city value, township value]
     * @return {string} res like: "{city value}{township value}"
     *
     *********************************************************************/
    arrayToString(array) {
        let res = "";

        for (let i = 0; i < array.length;){
            for (let j = 0; j < cities.length; ++j){
                if (cities[j].value === array[i]){
                    res += cities[j].label;
                    i++;
                    for (let k = 0; k < cities[j].children.length; k++){
                        if (array[i] === cities[j].children[k].value){
                            res += cities[j].children[k].label;
                            i++;
                        }
                    }
                }
            }
        }

        return res;
    },
}
